import type { SocialSignInFn } from "@ticketon/authentication-core";

const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT ?? "";

// Backend OAuth endpoint (mirrors ticketon-travel: `${API_BASE}/api/oauth`).
// The frontend only redirects here; the backend holds the Google client id/secret
// and performs the OAuth handshake.
const OAUTH_BASE = `${
  API_ENDPOINT.endsWith("/") ? API_ENDPOINT.slice(0, -1) : API_ENDPOINT
}/api/oauth`;

export const socialSignIn: SocialSignInFn = async (provider, callbackUrl) => {
  const params = new URLSearchParams();

  if (callbackUrl) {
    params.set("callbackUrl", callbackUrl);
  }
  params.set("frontendOrigin", window.location.origin);

  window.location.href = `${OAUTH_BASE}/${provider}?${params.toString()}`;
};
